import { NodeMetricKind } from '@scale/shared/dailyPlan/metrics/nodeMetrics';
import { MetricId } from 'react-scale/corp/views/DailyPlanning/DailyPlanning/components/utils';

export const SUBTASK_NODES_MAPPING = {
  start: 'Start',
  attempt: 'Attempt',
  finish: 'Finish',
  corp_review: 'L10 Review',
  review: 'Consensus Review',
  l0_review: 'L0 Review',
  l1_review: 'L1 Review',
  l12_review: 'L12 Review',
  corp_flagged: 'L11 Review',
  async_linting: 'Async Linting',
  expedite: 'Expedite',
  audit: 'Internal Audit',
  attempt_consensus: 'Attempt Consensus',
  review_consensus: 'Review Consensus',
  hold_deliverable: 'Hold deliverable (L12 Review)',
  redact_personal_data: 'Redact Personal Data',
  restore_non_compliant_response: 'Restore Non-Compliant Response',
  post_redact_review: 'Post-Redact Review',
  __$__: '__$__',
  __attempt__: '__Attempt__',
  __attempt_consensus__: '__Attempt Consensus__',
};

/**
 * This supports disabling certain metrics for specific node
 *
 * This is useful for nodes like 'start', where there isn't any data around ingress, which results in negative inventory values
 * */
export const DISABLED_METRIC_ROW_OVERRIDES: MetricId[] = [
  {
    nodeName: 'start',
    metricKind: NodeMetricKind.StartOfDayInventory,
  },
  {
    nodeName: 'finish',
    metricKind: NodeMetricKind.StartOfDayInventory,
  },
  {
    nodeName: 'canceled',
    metricKind: NodeMetricKind.StartOfDayInventory,
  },
  {
    nodeName: 'start',
    metricKind: NodeMetricKind.EndOfDayInventory,
  },
  {
    nodeName: 'finish',
    metricKind: NodeMetricKind.EndOfDayInventory,
  },
  {
    nodeName: 'canceled',
    metricKind: NodeMetricKind.EndOfDayInventory,
  },
  {
    nodeName: 'start',
    metricKind: NodeMetricKind.VolumeOfIngress,
  },
  {
    nodeName: 'start',
    metricKind: NodeMetricKind.VolumeOfTaskAttemptIngress,
  },
  {
    nodeName: 'start',
    metricKind: NodeMetricKind.VolumeOfNonTaskAttemptIngress,
  },
  {
    nodeName: 'finish',
    metricKind: NodeMetricKind.VolumeOfEgress,
  },
  {
    nodeName: 'canceled',
    metricKind: NodeMetricKind.VolumeOfEgress,
  },
  {
    nodeName: 'start',
    metricKind: NodeMetricKind.VolumeOfTaskAttemptEgress,
  },
  {
    nodeName: 'finish',
    metricKind: NodeMetricKind.VolumeOfTaskAttemptEgress,
  },
  {
    nodeName: 'canceled',
    metricKind: NodeMetricKind.VolumeOfTaskAttemptEgress,
  },
  {
    nodeName: 'audit',
    metricKind: NodeMetricKind.VolumeOfTaskAttemptEgress,
  },
  {
    nodeName: 'step_fn',
    metricKind: NodeMetricKind.VolumeOfTaskAttemptEgress,
  },
  {
    nodeName: 'start',
    metricKind: NodeMetricKind.ActiveTaskers,
  },
  {
    nodeName: 'finish',
    metricKind: NodeMetricKind.ActiveTaskers,
  },
  {
    nodeName: 'canceled',
    metricKind: NodeMetricKind.ActiveTaskers,
  },
  {
    nodeName: 'audit',
    metricKind: NodeMetricKind.ActiveTaskers,
  },
  {
    nodeName: 'step_fn',
    metricKind: NodeMetricKind.ActiveTaskers,
  },
  {
    nodeName: 'start',
    metricKind: NodeMetricKind.SubmissionPerActiveTasker,
  },
  {
    nodeName: 'finish',
    metricKind: NodeMetricKind.SubmissionPerActiveTasker,
  },
  {
    nodeName: 'canceled',
    metricKind: NodeMetricKind.SubmissionPerActiveTasker,
  },
  {
    nodeName: 'audit',
    metricKind: NodeMetricKind.SubmissionPerActiveTasker,
  },
  {
    nodeName: 'step_fn',
    metricKind: NodeMetricKind.SubmissionPerActiveTasker,
  },
  {
    nodeName: 'start',
    metricKind: NodeMetricKind.DistributionOfTaskAttemptEgressRate,
  },
  {
    nodeName: 'finish',
    metricKind: NodeMetricKind.DistributionOfTaskAttemptEgressRate,
  },
  {
    nodeName: 'canceled',
    metricKind: NodeMetricKind.DistributionOfTaskAttemptEgressRate,
  },
  {
    nodeName: 'audit',
    metricKind: NodeMetricKind.DistributionOfTaskAttemptEgressRate,
  },
  {
    nodeName: 'step_fn',
    metricKind: NodeMetricKind.DistributionOfTaskAttemptEgressRate,
  },
  {
    nodeName: 'start',
    metricKind: NodeMetricKind.DistributionOfTaskAttemptEgressVolume,
  },
  {
    nodeName: 'finish',
    metricKind: NodeMetricKind.DistributionOfTaskAttemptEgressVolume,
  },
  {
    nodeName: 'canceled',
    metricKind: NodeMetricKind.DistributionOfTaskAttemptEgressVolume,
  },
  {
    nodeName: 'audit',
    metricKind: NodeMetricKind.DistributionOfTaskAttemptEgressVolume,
  },
  {
    nodeName: 'step_fn',
    metricKind: NodeMetricKind.DistributionOfTaskAttemptEgressVolume,
  },
  {
    nodeName: 'finish',
    metricKind: NodeMetricKind.VolumeOfNonTaskAttemptEgress,
  },
  {
    nodeName: 'canceled',
    metricKind: NodeMetricKind.VolumeOfNonTaskAttemptEgress,
  },
  {
    nodeName: 'finish',
    metricKind: NodeMetricKind.DistributionOfNonTaskAttemptEgressRate,
  },
  {
    nodeName: 'canceled',
    metricKind: NodeMetricKind.DistributionOfNonTaskAttemptEgressRate,
  },
  {
    nodeName: 'finish',
    metricKind: NodeMetricKind.DistributionOfNonTaskAttemptEgressVolume,
  },
  {
    nodeName: 'canceled',
    metricKind: NodeMetricKind.DistributionOfNonTaskAttemptEgressVolume,
  },
];
